import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Snackbar, Alert, Button, Card, CardContent } from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import styles from '../styles/PromptManager.module.css';
import Sidebar from '../../Home/components/Sidebar';
import Tabs from '../../Home/components/Tabs';
import { API_ENDPOINTS, HTTP_METHODS } from '../../../constants/appConstants';
import { apiRequest } from '../services/promptManagerService';
import NodeDependencyDropDown from '../components/NodeDependencyDropDown.js';
import {
  FaAngleRight,
  FaAngleUp,
  FaAngleDown,
  FaTrashAlt,
  FaPencilAlt,
} from 'react-icons/fa';
import Header from '../../../components/common/Header/Header.js';
const PromptManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { token, handleLogout } = useAuth();
  const [activeTab, setActiveTab] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedTab, setSelectedTab] = useState('Category Management');
  const [categories, setCategories] = useState([]);
  const [categoryInputs, setCategoryInputs] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [promptText, setPromptText] = useState('');
  const [expectedOutput, setExpectedOutput] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  //const [ispromptCard, setIspromptCard] = useState(false);
  const [isPromptButton, setIsPromptButton] = useState(true);
  const [isNodeDependencyButton, setIsNodeDependencyButton] = useState(true);
  const [isPromptListVisible, setIsPromptListVisible] = useState(false);
  const [savedPrompts, setSavedPrompts] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editCategoryIndex, setEditCategoryIndex] = useState(null);
  const [savedCategories, setSavedCategories] = useState([]);
  const [isCategoryListVisible, setIsCategoryListVisible] = useState(false);
  const [isHideCategoriesListButton, setHideCategoriesListButton] =
    useState(false);
  const [isNodeDependencyListVisible, setIsNodeDependencyListVisible] =
    useState(false);
  const [editNodeDependencyIndex, setEditNodeDependencyIndex] = useState(null);
  const [optionsData, setOptionsData] = useState(null);
  const [nodeDependencies, setNodeDependencies] = useState([]);
  const toggleExpand = () => setIsExpanded(!isExpanded);
  const [isCardVisible, setIsCardVisible] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return; // Prevents closing when clicking outside
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, severity, isOpen) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(isOpen); // Use the isOpen parameter to control the snackbar's state
  };
  //if(selectedTab === "Category Management")   getNodeCategory();
  // if(selectedTab === "Prompt Management")   getPrompts();
  //   if(selectedTab === "Node Dependency")

  /* useEffect(() => {
    getNodeCategory();
    getPrompts();
    setIsNodeDependencyButton(false);
    getNodeDependencyList();

}, []); // Fetch again when `categories` change
*/

  //To Be checked later

  const findRelevantLabelsList = async (dependenciesResponse) => {
    const savedWorkflowsResponse = await apiRequest(
      API_ENDPOINTS.WORKFLOW_LIST,
      HTTP_METHODS.POST,
      { deleted_at: 'null' },
      token,
      handleLogout
    );

    if (
      !Array.isArray(dependenciesResponse) ||
      dependenciesResponse.length === 0
    )
      return [];
    const mappedDependencies = dependenciesResponse.map((dep) => {
      const workflowDetails = savedWorkflowsResponse.find(
        (workflow) => workflow.id === dep.wfw_id
      );

      const workflowName = workflowDetails
        ? workflowDetails.workflow_name
        : null;
      const workflowCategory = workflowDetails
        ? workflowDetails.workflow_category
        : null;

      const allnodes = savedWorkflowsResponse.flatMap((item) =>
        item.workflow.nodes.map((node) => ({
          id: node.id, // Include the ID
          label: node.data.label, // Include the label
        }))
      );

      let workflowNodeDetails = null;
      let workflowDependentNodeDetails = null;
      let nodeLabelVal = null;
      let nodeDependentLabelVal = null;

      let nodeIdVal = null;
      let nodeDependentIdVal = null;

      if (workflowDetails) {
        workflowNodeDetails = allnodes.find(
          (item) => item.id === dep.wfw_node_id
        );
        workflowDependentNodeDetails = allnodes.find(
          (item) => item.id === dep.wfw_node_dependent_id
        );
        nodeLabelVal = workflowNodeDetails ? workflowNodeDetails.label : null;
        nodeDependentLabelVal = workflowDependentNodeDetails
          ? workflowDependentNodeDetails.label
          : null;
        nodeIdVal = workflowNodeDetails ? workflowNodeDetails.id : null;
        nodeDependentIdVal = workflowDependentNodeDetails
          ? workflowDependentNodeDetails.id
          : null;
      }

      return {
        id: dep.id,
        workflowCategory: workflowCategory,
        workflowName: workflowName,
        nodeLabel: nodeLabelVal,
        nodeDependentLabel: nodeDependentLabelVal,
        workflowCategoryId: dep.wfw_category,
        workflowNameId: dep.wfw_id,
        nodeId: dep.wfw_node_id,
        nodeDependentId: dep.wfw_node_dependent_id,
      };
    });

    // setsavedWorkflows(workflowCategoryArr);

    //setWorkflowOptions(workflowCategoryArr);

    return mappedDependencies;

    // Fetch categories from `categoriesResponse` based on workflow ID
  };
  const getNodeDependencyList = async () => {
    const dependenciesResponse = await apiRequest(
      API_ENDPOINTS.WORKFLOW_RULES_LIST,
      HTTP_METHODS.POST,
      { deletedAt: 'null' },
      token,
      handleLogout
    );
    if (dependenciesResponse.success) {
      const labels = await findRelevantLabelsList(dependenciesResponse.data);

      setNodeDependencies(labels);
    }
  };

  useEffect(() => {
    if (selectedTab === 'Category Management') {
      getNodeCategory();
      setIsCategoryListVisible(true);
      getNodeDependencyList();
    } else if (selectedTab === 'Prompt Management') {
      getPrompts();
    } else if (selectedTab === 'Node Dependency') {
      if (nodeDependencies.length > 0) setIsCardVisible(true);
      else setIsCardVisible(true);
    }
  }, [selectedTab]); // Runs when `selectedTab` changes

  /*
  useEffect(() => {
    getNodeCategory();
}, [categories]); // Fetch again when `categories` change
*/

  const getPrompts = async () => {
    const savedPromptsResponse = await apiRequest(
      API_ENDPOINTS.PROMPT_LIST,
      HTTP_METHODS.POST,
      {
        deletedAt: 'null',
      },
      token,
      handleLogout
    );

    if (savedPromptsResponse.success) {
      setSavedPrompts(savedPromptsResponse.data);
    }
    setIsPromptListVisible(true);
  };
  const getNodeCategory = async () => {
    try {
      const savedCategoriesResponse = await apiRequest(
        API_ENDPOINTS.CATEGORY_LIST,
        HTTP_METHODS.POST,
        { deletedAt: 'null' },
        token,
        handleLogout
      );
      if (savedCategoriesResponse?.data) {
        const categories = savedCategoriesResponse.data.reduce((acc, item) => {
          acc[item.category_name] = {
            name: item.category_name,
            slug: item.category_slug,
            id: item.id,
            workflows: {}, // Initialize with empty workflows
          };
          return acc;
        }, {});
        setSavedCategories(savedCategoriesResponse.data);
        setIsCategoryListVisible(true);
        setCategories([]);
        setOptionsData(categories);
      }
      //showSnackbar("Category loaded successfully!","success",true)
    } catch (error) {
      console.error('Error fetching categories:', error);
      showSnackbar(
        'Error loading categories. Please try again.',
        'error',
        true
      );
    }
  };

  const handleCategoryInputChange = (index, value) => {
    const newInputs = [...categoryInputs];
    newInputs[index] = value;

    const trimmedValue = value.trim();
    if (trimmedValue.length > 50) {
      showSnackbar(
        'Category Name cannot be more than 50 characters.',
        'error',
        true
      );
      return;
    }

    setCategoryInputs(newInputs);
  };

  const addCategory = () => {
    setCategories([...categories, '']);
    setCategoryInputs([...categoryInputs, '']);
    setIsCategoryListVisible(false);
    setSavedCategories([]);
  };

  const addPrompt = () => {
    setIsPromptButton(false);
  };

  const addNodeDependency = () => {
    setIsNodeDependencyListVisible(false);
    setIsNodeDependencyButton(false);
    setIsCardVisible(true);
  };

  const savePrompt = async () => {
    // Validate input fields
    /*if (!promptText.trim() || !expectedOutput.trim()) {
      showSnackbar("Please enter both Prompt Text and Expected Output", "warning", true);
      return;
    }*/

    if (!promptText.trim()) {
      showSnackbar('Please enter Prompt Text', 'warning', true);
      return;
    }

    try {
      let response;

      if (editIndex !== null) {
        // Editing an existing prompt
        const updatedPrompts = [...savedPrompts];
        updatedPrompts[editIndex] = {
          ...updatedPrompts[editIndex],
          prompt_name: promptText,
          // prompt_description: expectedOutput,
        };

        //console.log(updatedPrompts, "Updated Prompts");

        setSavedPrompts(updatedPrompts);

        // API call to update prompt
        const updatePromptUrl = `${API_ENDPOINTS.UPDATE_PROMPT}/${editIndex}`;
        response = await apiRequest(
          updatePromptUrl,
          HTTP_METHODS.PUT,
          {
            promptName: promptText,
            promptDescription: expectedOutput,
          },
          token,
          handleLogout
        );

        if (!response.success) {
          throw new Error(response.error || 'Failed to update Prompt');
        }

        showSnackbar('Prompt updated successfully!', 'success', true);
      } else {
        // Creating a new prompt
        response = await apiRequest(
          API_ENDPOINTS.CREATE_PROMPT,
          HTTP_METHODS.POST,
          {
            promptName: promptText,
            promptDescription: promptText,
          },
          token,
          handleLogout
        );

        if (!response.success) {
          throw new Error(response.error || 'Failed to save Prompt');
        }

        showSnackbar('Prompt saved successfully!', 'success', true);
      }

      // Fetch the updated list of prompts after saving
      const savedPromptsResponse = await apiRequest(
        API_ENDPOINTS.PROMPT_LIST,
        HTTP_METHODS.POST,
        {
          deletedAt: 'null',
        },
        token,
        handleLogout
      );

      if (savedPromptsResponse.success) {
        setSavedPrompts(savedPromptsResponse.data);
      }

      // Reset input fields and UI state after successful save
      setPromptText('');
      setExpectedOutput('');
      setEditIndex(null);
      setIsPromptButton(true);
      setIsPromptListVisible(true);
    } catch (error) {
      console.error('Error saving prompt:', error);
      showSnackbar(error.message || 'An error occurred', 'error', true);
    }
  };

  const saveCategory = async () => {
    try {
      // 1. **Validation checks**
      if (categoryInputs.length === 0) {
        showSnackbar(
          'At least one category is required before saving.',
          'warning',
          true
        );
        return;
      }

      if (categoryInputs.some((name) => name.trim() === '')) {
        showSnackbar('Category names cannot be empty.', 'warning', true);
        return;
      }

      // 2. **Format category input**
      const formattedCategories = categoryInputs[0]?.trim();
      setIsCategoryListVisible(true);

      // 3. **API call to create category**
      const response = await apiRequest(
        API_ENDPOINTS.CREATE_CATEGORY,
        HTTP_METHODS.POST,
        { categoryName: formattedCategories },
        token,
        handleLogout
      );

      //  console.log("CREATE_CATEGORY API Response:", response);

      if (response?.error) {
        showSnackbar(response.error, 'error', true);
        // 6. **Reset input fields and category list**
        setCategories([]);
        setCategoryInputs([]);
        setCategoriesList([]);
        return;
      }

      if (!response?.success) {
        console.error('Failed to save category:', response);
        showSnackbar(
          response?.error || 'Failed to save category',
          'error',
          true
        );
        return;
      }

      // 4. **Fetch updated category list**
      const savedCategoriesResponse = await apiRequest(
        API_ENDPOINTS.CATEGORY_LIST,
        HTTP_METHODS.POST,
        { deletedAt: 'null' },
        token,
        handleLogout
      );

      console.log('CATEGORY_LIST API Response:', savedCategoriesResponse);

      if (!savedCategoriesResponse?.success) {
        console.error(
          'Failed to fetch updated categories:',
          savedCategoriesResponse
        );
        showSnackbar('Could not refresh category list.', 'warning', true);
        return;
      }

      // 5. **Update state with the latest categories**
      setSavedCategories(savedCategoriesResponse.data);
      showSnackbar('Category saved successfully!', 'success', true);
      getNodeCategory();

      // 6. **Reset input fields and category list**
      setCategories([]);
      setCategoryInputs([]);
      setCategoriesList([]);
    } catch (error) {
      console.error('Unexpected error in saveCategory:', error);
      showSnackbar('Error saving category. Please try again', 'error', true);
    }
  };

  const deleteCategory = async (categoryId) => {
    const deleteCategoryUrl = `${API_ENDPOINTS.DELETE_CATEGORY}/${categoryId}`;
    try {
      const response = await apiRequest(
        deleteCategoryUrl,
        HTTP_METHODS.DELETE,
        {},
        token,
        handleLogout
      );
      if (!response.success) {
        showSnackbar(
          'Failed to delete category. Please try again.',
          'error',
          true
        );

        throw new Error('Failed to delete category');
      }
      const updatedCategories = savedCategories.filter(
        (category) => category.id !== categoryId
      );
      setSavedCategories(updatedCategories);
      showSnackbar('Category deleted successfully!', 'success', true);
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  };

  const editPrompt = (promptId) => {
    const promptToEdit = savedPrompts.find((prompt) => prompt.id === promptId);
    if (promptToEdit) {
      // Extract the prompt_name and prompt_description
      const { prompt_name, prompt_description } = promptToEdit;
      setPromptText(prompt_name);
      setExpectedOutput(prompt_description);
    }
    setEditIndex(promptId);
    setIsPromptButton(false);
  };

  const handlePromptChange = (e) => {
    const inputValue = e.target.value; // Get the current input value
    console.log(inputValue, 'inputValue');

    if (inputValue.length > 50) {
      showSnackbar('Prompt cannot be more than 50 characters.', 'error', true);
      return;
    }

    setPromptText(inputValue); // Don't trim here to allow spaces
  };

  const handleExpectedChange = (e) => {
    const inputValue = e.target.value; // Get the current input value

    if (inputValue.length > 50) {
      showSnackbar(
        'Expected Output cannot be more than 50 characters.',
        'error',
        true
      );
      return;
    }

    setExpectedOutput(inputValue); // Don't trim here to allow spaces
  };
  const deletePrompt = async (promptId) => {
    const deleteCategoryUrl = `${API_ENDPOINTS.DELETE_PROMPT}/${promptId}`;
    try {
      const response = await apiRequest(
        deleteCategoryUrl,
        HTTP_METHODS.DELETE,
        {},
        token,
        handleLogout
      );
      if (!response.success) {
        showSnackbar(
          'Failed to delete prompt. Please try again.',
          'error',
          true
        );
        throw new Error('Failed to delete prompt');
      }
      const updatedPrompts = savedPrompts.filter(
        (prompt) => prompt.id !== promptId
      );
      setSavedPrompts(updatedPrompts);
      showSnackbar('Prompt deleted successfully!', 'success', true);
    } catch (error) {
      console.error('Error deleting Prompt:', error);
    }
  };

  const tabs = ['Category Management', 'Prompt Management']; //["Category Management", "Prompt Management", "Node Dependency"];
  return (
    <div style={{ display: 'flex', height: '150vh' }}>
      <Header />
      <Sidebar active={'prompt-manager'} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div className={styles.mainTab}>
        {/* <Tabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}
        <h2
          style={{
            fontSize: '18px',
            fontWeight: '600',
            marginTop: '30px',
            marginBottom: '20px',
          }}
        >
          Work Flow Rules & Prompt Management
        </h2>

        <div className={styles.content}>
          <div className={styles.layoutContainer}>
            <div className={styles.tabContainer}>
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setSelectedTab(tab)}
                  className={`${styles['tab-button']} ${selectedTab === tab ? styles['active'] : ''}`}
                >
                  {tab}
                  {selectedTab === tab && (
                    <FaAngleRight className={styles.tabIcon} />
                  )}
                </button>
              ))}
            </div>
            <Card
              className={`shadow-lg ${isExpanded ? styles.expandedCard : styles.collapsedCard} ${styles.mobileCard}`}
            >
              <CardContent style={{ padding: '16px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={toggleExpand}
                >
                  <h3 style={{ fontSize: '18px', fontWeight: '600' }}>
                    {selectedTab}
                  </h3>
                  {isExpanded ? (
                    <FaAngleUp style={{ color: '#A1A1A1' }} />
                  ) : (
                    <FaAngleDown style={{ color: '#A1A1A1' }} />
                  )}
                </div>

                {isExpanded && (
                  <>
                    <p
                      style={{
                        color: '#666',
                        fontSize: '14px',
                        marginTop: '8px',
                      }}
                    >
                      {selectedTab === 'Category Management' &&
                        'This category will be shown in the workflow.'}
                      {selectedTab === 'Prompt Management' &&
                        'Manage prompts for workflow automation.'}
                      {selectedTab === 'Node Dependency' &&
                        'Define dependencies between workflow nodes.'}
                    </p>

                    {selectedTab === 'Category Management' &&
                      !isCategoryListVisible &&
                      categories.length > 0 &&
                      categories.map((category, index) => (
                        <div
                          key={category.id || index}
                          className={styles.categoryCard}
                        >
                          <Card className={styles.rulecard}>
                            <label className={styles.cardlabel}>
                              Category Name
                            </label>
                            <input
                              type="text"
                              value={categoryInputs[index]}
                              onChange={(e) =>
                                handleCategoryInputChange(index, e.target.value)
                              }
                              className={styles.cardinput}
                              placeholder="Enter category name"
                              maxLength={51} // Ensures users can't type more than 50 chars
                            />

                            <div className={styles.buttonContainerCategory}>
                              <button
                                onClick={saveCategory}
                                className={`${styles.saveButton} ${
                                  categoryInputs.some(
                                    (name) => name.trim() !== ''
                                  )
                                    ? styles.saveButtonEnabled
                                    : styles.saveButtonDisabled
                                }`}
                                disabled={categoryInputs.every(
                                  (name) => name.trim() === ''
                                )}
                              >
                                Save
                              </button>
                            </div>
                          </Card>
                        </div>
                      ))}
                    {selectedTab === 'Prompt Management' && !isPromptButton && (
                      <div className={styles.categoryCard}>
                        <Card className={styles.rulecard}>
                          <div>
                            <label className={styles.cardlabel}>
                              Prompt Text
                            </label>
                            <input
                              type="text"
                              style={{ marginBottom: 20 }}
                              value={promptText}
                              onChange={handlePromptChange}
                              className={styles.cardinput}
                              placeholder="Prompt Text"
                              maxLength={51} // Ensures users can't type more than 50 chars
                            />
                          </div>

                          <div style={{ display: 'none' }}>
                            <label className={styles.cardlabel}>
                              Expected Output
                            </label>
                            <input
                              type="text"
                              value={expectedOutput}
                              onChange={handleExpectedChange}
                              className={styles.cardinput}
                              placeholder="Expected Output"
                              maxLength={51} // Ensures users can't type more than 50 chars
                            />
                          </div>

                          <button
                            onClick={savePrompt}
                            className={`${styles.saveButton} ${
                              promptText.trim() !== ''
                                ? styles.saveButtonEnabled
                                : styles.saveButtonDisabled
                            } saveButtonCustom`}
                            disabled={promptText.trim() === ''}
                          >
                            {editIndex !== null ? 'Update' : 'Save'}
                          </button>
                        </Card>
                      </div>
                    )}

                    {selectedTab === 'Node Dependency' && (
                      <>
                        {isNodeDependencyButton && (
                          <div>
                            <div className={styles.buttonContainer}>
                              <Button
                                onClick={addNodeDependency}
                                className={styles.addPromptButton}
                              >
                                + Add Node Dependency
                              </Button>
                            </div>
                          </div>
                        )}

                        <div className={styles.nodeDependencyOuterCard}>
                          <Card
                            className={
                              nodeDependencies.length > 0
                                ? styles.rulecard
                                : styles.rulecard
                            }
                            style={{
                              overflow: 'visible',
                              display: isCardVisible ? 'block' : 'none',
                            }}
                          >
                            <NodeDependencyDropDown
                              optionsData={optionsData}
                              nodeDependencies={nodeDependencies}
                              setNodeDependencies={setNodeDependencies}
                              isNodeDependencyListVisible={
                                isNodeDependencyListVisible
                              }
                              setIsNodeDependencyListVisible={
                                setIsNodeDependencyListVisible
                              }
                              setIsNodeDependencyButton={
                                setIsNodeDependencyButton
                              }
                              editNodeDependencyIndex={editNodeDependencyIndex}
                              setEditNodeDependencyIndex={
                                setEditNodeDependencyIndex
                              }
                              setSnackbarMessage={setSnackbarMessage}
                              setSnackbarSeverity={setSnackbarSeverity}
                              setSnackbarOpen={setSnackbarOpen}
                              isCardVisible={isCardVisible}
                              setIsCardVisible={setIsCardVisible}
                            />
                          </Card>
                        </div>
                      </>
                    )}

                    {(categories.length <= 0 || isCategoryListVisible) &&
                      selectedTab === 'Category Management' && (
                        <div className={styles.buttonContainer}>
                          <Button
                            onClick={addCategory}
                            className={styles.addCategoryButton}
                          >
                            + Add New Category
                          </Button>
                        </div>
                      )}

                    {isCategoryListVisible &&
                      selectedTab === 'Category Management' && (
                        <div className={styles.categoryCard}>
                          {savedCategories.length > 0 && (
                            <div>
                              <h3 className={styles.addedPromptTitle}>
                                Added Category
                              </h3>
                              <label className={styles.cardlabel}>
                                Category Name:
                              </label>
                              <div className={styles.categoryList}>
                                {savedCategories.map((item) => (
                                  <div
                                    key={item.id}
                                    className={styles.categoryContainer}
                                  >
                                    <div className={styles.categoryHeader}>
                                      <span className={styles.categoryName}>
                                        {item.category_name}
                                      </span>

                                      <div
                                        className={
                                          styles.editdeleteButtonContainer
                                        }
                                      >
                                        <button
                                          onClick={() =>
                                            deleteCategory(item.id)
                                          }
                                          className={styles.deleteButton}
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                    {isPromptButton && selectedTab === 'Prompt Management' && (
                      <div>
                        <div className={styles.buttonContainer}>
                          <Button
                            onClick={addPrompt}
                            className={styles.addPromptButton}
                          >
                            + Add Prompt
                          </Button>
                        </div>

                        {isPromptListVisible && (
                          <div className={styles.categoryCard}>
                            {savedPrompts.length > 0 && (
                              <div>
                                <h3 className={styles.addedPromptTitle}>
                                  Added Prompt
                                </h3>
                                <div className={styles.categoryList}>
                                  {savedPrompts.map((item) => (
                                    <div
                                      key={item.id}
                                      className={styles.promptContainer}
                                    >
                                      <div className={styles.promptContent}>
                                        <p className={styles.promptText}>
                                          {item.prompt_name}
                                        </p>
                                        {/*<hr className={styles.divider} />
                               <p className={styles.expectedOutput}>{item.prompt_description}</p>*/}
                                      </div>
                                      <div
                                        className={styles.iconContainer}
                                        style={{ margin: 10 }}
                                      >
                                        <FaPencilAlt
                                          onClick={() => editPrompt(item.id)}
                                          className={styles.editIcon}
                                        />
                                        <FaTrashAlt
                                          onClick={() => deletePrompt(item.id)}
                                          className={styles.deleteIcon}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptManager;
